import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import type { MenuOptions } from "@circleco/compass/components/Menu";
import { Link } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import {
  isCommunityAdmin,
  isCommunityModerator,
} from "@/react/helpers/communityMemberHelpers";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";

import { adminV4Icons } from "../adminV4Icons";

export const useContentPageMenuLink = (): MenuOptions => {
  const { currentCommunityMember } = usePunditUserContext();

  const isVisible = Boolean(
    isCommunityAdmin(currentCommunityMember) ||
    isCommunityModerator(currentCommunityMember),
  );

  if (!isVisible) return [];

  const title = t("settings_nav_v3.content.label");
  const link = isCommunityAdmin(currentCommunityMember)
    ? settingsNavPathV3.content.files
    : settingsNavPathV3.content.posts;

  return [
    {
      label: title,
      icon: adminV4Icons.contentIcon,
      renderLink: <Link to={link} />,
    },
  ];
};
